import { EndpointCallParams } from '@core/api/endpointCallParams';

import { IApiStore } from '@core/api/apiStore';

export type GetEntityParams = {
  id: string;
};

export const performGetEntities = async (api: IApiStore, params: EndpointCallParams<{}>) => {
    const { payload, ...rest } = params;
    const req = api
        .get('neoanalytics-app/api/v1/entities', {
            ...rest,
            payload: { ...payload },
        })

    return req;
}

export const performGetEntity = async (api: IApiStore, params: EndpointCallParams<GetEntityParams>) => {
    const { payload, ...rest } = params;
    const req = api
        .get(`neoanalytics-app/api/v1/entities/${payload.id}`, {
            ...rest,
            payload: { ...payload },
        })

    return req;
}
